import i18next from 'i18next'
import * as yup from 'yup'

import { VariableType } from '@pages/ContextMenuCreateOrEdit'

export const contextMenuSchema = yup.object().shape({
  variables: yup.array().of(
    yup.object().shape({
      field: yup
        .string()
        .test('required', '', val => Boolean(val?.trim()))
        .test('unique', '', function (value, ctx) {
          return this.from
            ?.at(-1)
            ?.value.variables.filter((variable: VariableType) => variable.field === value).length >
            1
            ? ctx.createError({ message: i18next.t('alreadyError', { value }), path: ctx.path })
            : true
        }),
    })
  ),
  title: yup.string().test('required', '', val => Boolean(val?.trim())),
  object: yup.object().shape({
    id: yup.string().test('required', '', val => Boolean(val?.trim())),
    label: yup.string().test('required', '', val => Boolean(val?.trim())),
  }),
  applicableTo: yup
    .object()
    .shape({
      id: yup.string(),
      label: yup.string(),
    })
    .nullable()
    .optional(),
})
